<template>
  <div>
    <OnboardingTextSection>
      Внутри каждого аккаунта находится таблица, где<br>
      отображена <b>основная информация</b> об аккаунтах или<br>
      проектах, которые в нём находятся.
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';

  export default {
    name: 'AccountTableStep',
    components: {OnboardingTextSection}
  };
</script>
